import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0a258b15"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = ["innerHTML"];
var _hoisted_2 = ["innerHTML"];
var _hoisted_3 = ["src", "alt"];
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "spacer"
  }, null, -1);
});
var _hoisted_7 = {
  key: 5,
  "class": "dots"
};
var _hoisted_8 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  return _openBlock(), _createElementBlock("div", {
    "class": "carousel-container",
    onTouchstart: _cache[5] || (_cache[5] = function () {
      return _ctx.handleTouchStart && _ctx.handleTouchStart.apply(_ctx, arguments);
    }),
    onTouchend: _cache[6] || (_cache[6] = function () {
      return _ctx.handleTouchEnd && _ctx.handleTouchEnd.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", {
    "class": "carousel-wrapper",
    style: _normalizeStyle(_ctx.carouselWrapperStyle)
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      "class": "carousel-item",
      key: index
    }, [item.topTitle ? (_openBlock(), _createElementBlock("p", {
      key: 0,
      "class": "topTitle",
      innerHTML: item.topTitle
    }, null, 8, _hoisted_1)) : _createCommentVNode("", true), item.topSummary ? (_openBlock(), _createElementBlock("p", {
      key: 1,
      "class": "topSummary",
      innerHTML: item.topSummary
    }, null, 8, _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("img", {
      "class": "image",
      src: item.image,
      alt: item.title,
      style: _normalizeStyle(_ctx.dynamicImageStyle(item))
    }, null, 12, _hoisted_3), item.header ? (_openBlock(), _createElementBlock("h3", {
      key: 2,
      "class": "header",
      innerHTML: item.header
    }, null, 8, _hoisted_4)) : _createCommentVNode("", true), item.description ? (_openBlock(), _createElementBlock("p", {
      key: 3,
      "class": "description",
      innerHTML: item.description
    }, null, 8, _hoisted_5)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, 'slot' + (index + 1), {}, undefined, true), _hoisted_6]);
  }), 128))], 4), _ctx.showArrows ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    "class": "arrow left-arrow",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.prev && _ctx.prev.apply(_ctx, arguments);
    })
  }, "<")) : _createCommentVNode("", true), _ctx.showArrows ? (_openBlock(), _createElementBlock("button", {
    key: 1,
    "class": "arrow right-arrow",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.next && _ctx.next.apply(_ctx, arguments);
    })
  }, ">")) : _createCommentVNode("", true), _ctx.showNextButtons && _ctx.currentIndex === 0 && (!_ctx.items[_ctx.currentIndex].hideNextButton || _ctx.items[_ctx.currentIndex].hideNextButton && _ctx.items[_ctx.currentIndex].hideNextButton === false) ? (_openBlock(), _createElementBlock("button", {
    key: 2,
    "class": "nextButton nextButton--centered",
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.next && _ctx.next.apply(_ctx, arguments);
    })
  }, [_createTextVNode(_toDisplayString(_ctx.items[_ctx.currentIndex].nextButtonLabel ? _ctx.items[_ctx.currentIndex].nextButtonLabel : 'Next') + " ", 1), _createVNode(_component_font_awesome_icon, {
    icon: _ctx.items[_ctx.currentIndex].nextButtonIcon ? _ctx.items[_ctx.currentIndex].nextButtonIcon : ['fa', 'chevron-right']
  }, null, 8, ["icon"])])) : _createCommentVNode("", true), _ctx.showNextButtons && _ctx.currentIndex > 0 && (!_ctx.items[_ctx.currentIndex].hideNextButton || _ctx.items[_ctx.currentIndex].hideNextButton && _ctx.items[_ctx.currentIndex].hideNextButton === false) ? (_openBlock(), _createElementBlock("button", {
    key: 3,
    "class": "nextButton",
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.next && _ctx.next.apply(_ctx, arguments);
    })
  }, [_createTextVNode(_toDisplayString(_ctx.items[_ctx.currentIndex].nextButtonLabel ? _ctx.items[_ctx.currentIndex].nextButtonLabel : 'Next') + " ", 1), _createVNode(_component_font_awesome_icon, {
    icon: _ctx.items[_ctx.currentIndex].nextButtonIcon ? _ctx.items[_ctx.currentIndex].nextButtonIcon : ['fa', 'chevron-right']
  }, null, 8, ["icon"])])) : _createCommentVNode("", true), _ctx.showNextButtons && _ctx.currentIndex > 0 && (!_ctx.items[_ctx.currentIndex].hidePreviousButton || _ctx.items[_ctx.currentIndex].hidePreviousButton && _ctx.items[_ctx.currentIndex].hidePreviousButton === false) ? (_openBlock(), _createElementBlock("button", {
    key: 4,
    "class": "previousButton",
    onClick: _cache[4] || (_cache[4] = function () {
      return _ctx.prev && _ctx.prev.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_font_awesome_icon, {
    icon: ['fa', 'chevron-left']
  }), _createTextVNode(" Previous ")])) : _createCommentVNode("", true), _ctx.currentIndex > 0 && (!_ctx.items[_ctx.currentIndex].hidePreviousButton || _ctx.items[_ctx.currentIndex].hidePreviousButton && _ctx.items[_ctx.currentIndex].hidePreviousButton === false) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.length, function (n) {
    return _openBlock(), _createElementBlock("span", {
      key: n,
      "class": _normalizeClass({
        'active': n - 1 === _ctx.currentIndex
      }),
      onClick: function onClick($event) {
        return _ctx.goTo(n - 1);
      }
    }, null, 10, _hoisted_8);
  }), 128))])) : _createCommentVNode("", true)], 32);
}